import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import type {
  GetCandidateGoodsListRequest,
  GetCandidateGoodsListResponse
} from '../../../app/kymw/kymw74/kymw7401/api-service/get-candidate-goods-list.service';

export const kymw7401Handlers = [
  // KYMW7401: 候補一覧取得 /kymw74/getCandidateGoodsList
  http.post(PlessService.SERVICE.KYMW74getCandidateGoodsList.url, async ({ request }) => {
    const req = await request.json() as { data: GetCandidateGoodsListRequest };
    console.log(PlessService.SERVICE.getSelectedGoodsFlgResult.url, req);

    const listLength = 5;
    const list = Array.from({ length: listLength }, (_, index) => (
      {
        ItemCode: Math.floor(Math.random() * 9000000 + 1000000).toString(), // ランダムな7桁の整数を生成
        PCode: `P${(index + 1).toString().padStart(7, '0')}`, // 「P＋ゼロ埋め7桁番号」を生成
        ClassCode: "01",
        ClassName: "部門名１",
        BuyerCode: "00100001",
        BuyerName: "バイヤー名１",
        GuideGoodsName: `商品名${(index + 1)}`,
        GuideStandardName: `企画名${(index + 1)}`,
        MakerName: "メーカー名１",
        PayeeClientCode: "100001",
        PayeeClientKanji: "支払先取引先名１",
        RegularRegistDate: "2025年09月02日"
      }
    ));
    getCandidateGoodsListResponse.result.obj.CandidateGoodsList = list;

    return HttpResponse.json(getCandidateGoodsListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getCandidateGoodsListResponse: {
  status: string;
  message: string;
  result: { obj: GetCandidateGoodsListResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CandidateGoodsList: []
    }
  }
};
